import React from "react";

const IconJobsFilled = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        d="M4 8v3h16V8h-3.917l-.163-.801a4.002 4.002 0 0 0-7.84 0L7.917 8H4zm12.243 0H7.757l.47-1.333a4 4 0 0 1 7.545 0L16.243 8zM10 15H4v5h16v-5h-6v2h-4v-2z"
        stroke="currentColor"
        strokeWidth={2}
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default IconJobsFilled;
